import React from 'react';
import PropTypes from 'prop-types';
import MaterialSwitch from '@material-ui/core/Switch';
import FormControlLabel from '@material-ui/core/FormControlLabel';

const Switch = (props) => {
    return (
        <FormControlLabel label={props.label}
                          control={
                              <MaterialSwitch color="secondary" size="small"
                                              checked={props.checked} onChange={props.onChange}
                              />
                          }
        />
    );
};

Switch.propTypes = {
    label: PropTypes.string.isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
};

export default Switch;
